//公共 -登录 -刷新token
import publicAPI from './publicAPI.js'
// 个人中心
import personCenterAPI from './personCenterAPI.js'
// 商品
import productAPI from './productAPI.js'

let urlList = Object.assign(
  {},publicAPI,personCenterAPI,productAPI
)
export default urlList



// WEBPACK FOOTER //
// ./src/api/api.js